import React from "react"
import { rem } from "polished"
import styled from "styled-components"
import { media } from "@sr/common"
import { SemiBdTitle3 } from "@sr/gatsby-theme-ui"

const essex =
  "https://res.cloudinary.com/smartrent-com/image/upload/v1714166548/pages/hardware/Essex_jgpdzm.svg"
const starwood =
  "https://res.cloudinary.com/smartrent-com/image/upload/v1714166547/pages/hardware/Starwood_Capital_Group_owbapx.svg"
const equity =
  "https://res.cloudinary.com/smartrent-com/image/upload/v1714166550/pages/hardware/Equity_Residential_pawhj9.svg"
const edwardRose =
  "https://res.cloudinary.com/smartrent-com/image/upload/v1715640877/pages/hardware/ers-100th-anniversary-logo_resizedweb-1_qmbwtd.png"
const cortland =
  "https://res.cloudinary.com/smartrent-com/image/upload/v1714166547/pages/hardware/Cortland_p3m1f5.svg"

const HardwareCategoryTrustedPartners = () => {
  return (
    <HardwareCategoryTrustedPartnersStyled>
      <SemiBdTitle3>Trusted by the biggest brands in multifamily</SemiBdTitle3>

      <div className="logos__logo-container">
        <img src={essex} alt="Essex" />
        <img src={starwood} alt="Starwood Capital Group" />
        <img src={equity} alt="Equity Residential" />
        <img src={edwardRose} alt="Edward Rose & Sons" />
        <img src={cortland} alt="Cortland" />
      </div>
    </HardwareCategoryTrustedPartnersStyled>
  )
}

export default HardwareCategoryTrustedPartners

export const HardwareCategoryTrustedPartnersStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: ${rem(56)} ${rem(16)};

  h3 {
    font-size: ${rem(32)};
    line-height: ${rem(40)};
    max-width: ${rem(300)};

    @media ${media.midUp} {
      font-size: ${rem(40)};
      line-height: ${rem(48)};
      max-width: ${rem(509)};
    }
  }

  .logos__logo-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: ${rem(242)};
    padding-top: ${rem(24)};

    @media ${media.midUp} {
      padding-top: ${rem(30)};
      flex-direction: row;
      flex-wrap: wrap;
      max-width: ${rem(744)};
    }

    @media ${media.stMidUp} {
      max-width: ${rem(1440)};
      gap: ${rem(24)};
    }

    img {
      object-fit: cover;
    }
  }
`
